import storage from './storage'


//获取cookie
function getCookie (cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  console.log("获取cookie,现在循环")
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    console.log(c)
    while (c.charAt(0) == ' ')
      c = c.substring(1);
    if (c.indexOf(name) != -1){
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

//设置cookie,增加到vue实例方便全局调用
function setCookie (c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);

  var millisecond = new Date().getTime();
  var expiresTime = new Date(millisecond + expiredays *  60 * 1000);

  document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + expiresTime);
};

//删除cookie
function delCookie (name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};

function addMinutes(mins){
  var exp = new Date();
  exp.setTime(exp.getTime() + mins * 60 *1000);
  console.log(exp);
  return exp;
}

//获取cookie、
function getCookie2(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return null;
}

export default {
  getCookie: function (name) {
    let ati= storage.get("ati");
    let admin =  storage.get("admin")
    if(admin != null) {
      ati = "0000000000"
    }else if(ati == null) {
      storage.set("ati", ati);
      ati = getCookie(name);
    }
    return ati;
  },

  setCookie: function (c_name, value, expiredays){
    setCookie(c_name, value, expiredays);
  },

  addMinutes: function (mins){
    return addMinutes(mins);
  }

}



// WEBPACK FOOTER //
// ./src/api/cookie.js